// extracted by mini-css-extract-plugin
module.exports = {"btn":"GoHome_btn__3nRnH","text":"GoHome_text__2jbDg","svgBtn":"GoHome_svgBtn__32mc1"};